const Data = [
  {
    id: 1,
    patient: "Bobbie Martel",
    appointment: "Dec 12th at 2:30pm",
    isCompleted: false,
    doctor: "Prof. Akari Yoshino",
    reason: "Check-up",
  },
  {
    id: 2,
    patient: "Kristie Keegan",
    appointment: "Dec 13th at 1:30pm",
    isCompleted: true,
    doctor: "Dr. Alena Mangold",
    reason: "Emergency",
  },
  {
    id: 3,
    patient: "Erik Neumann",
    appointment: "Dec 14th at 3:00pm",
    isCompleted: false,
    doctor: "Dr. Lian Kurzmann",
    reason: "Follow-up",
  },
  {
    id: 4,
    patient: "Boyd Regenbogen",
    appointment: "Dec 12th at 2:30pm",
    isCompleted: false,
    doctor: "Prof. Dr. Benjamin Daley",
    reason: "Check-up",
  },
  {
    id: 5,
    patient: "Darla Mueller",
    appointment: "Dec 13th at 1:30pm",
    isCompleted: true,
    doctor: "MD. Eva Manz",
    reason: "Routine",
  },
  {
    id: 6,
    patient: "Dot Kuntz",
    appointment: "Dec 14th at 3:00pm",
    isCompleted: false,
    doctor: "Prof. Dr. Theodor Jackson",
    reason: "Walkin",
  },
  {
    id: 7,
    patient: "Ella Chester",
    appointment: "Dec 14th at 3:00pm",
    isCompleted: false,
    doctor: "Dr. Nari Chung",
    reason: "Emergency",
  },
  {
    id: 8,
    patient: "Elisa Daniel",
    appointment: "Dec 14th at 3:00pm",
    isCompleted: false,
    doctor: "Ass. Prof. Dr. Wulf Gabler",
    reason: "Routine",
  },
  {
    id: 9,
    patient: "Timmy Donaldson",
    appointment: "Dec 12th at 2:30pm",
    isCompleted: false,
    doctor: "Prof. Dr. Benjamin Daley",
    reason: "Check-up",
  },
];
export default Data;
